import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "formgrid grid" }
const _hoisted_3 = { class: "field col-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "ic" }, "IČ", -1)
const _hoisted_5 = {
  class: "p-inputgroup",
  id: "ic"
}
const _hoisted_6 = {
  key: 0,
  class: "p-error"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "dic" }, "DIC", -1)
const _hoisted_8 = { class: "field col-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = { class: "formgrid grid" }
const _hoisted_12 = { class: "formgrid grid" }
const _hoisted_13 = { class: "field col-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, " ", -1)

import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
import Panel from 'primevue/panel'
import InputSwitch from 'primevue/inputswitch'

import {AxiosStatic} from "axios";
import {inject, reactive, ref, withDefaults} from "vue";
import useVuelidate from "@vuelidate/core";
import {email, required, requiredIf} from "@vuelidate/validators";
import InputField from "@/components/blocks/InputField.vue";
import {useUserStore} from "@/stores/UserStore";

// Define types
type ComponentProps = {
    collapsed?: boolean
}

type FormData = {
    ic: string | null
    companyName: string | null,
    dic: string | null,
    platceDph: boolean,
    okres: string | null,
    obec: string | null,
    castObce: string | null,
    ulice: string | null,
    cisloDomu: string | null,
    psc: string | null,
    email: string | null,
    phone: string | null,
    bankAccountNumber: string | null
}

// Define component properties

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateCompanyForm',
  props: {
    collapsed: { type: Boolean, default: true }
  },
  emits: ['companyCreated'],
  setup(__props: any, { emit: emits }) {

const props = __props as { collapsed: boolean };





// Define component data
const formData = reactive<FormData>({
    ic: '71857001',
    companyName: null,
    dic: null,
    platceDph: false,
    okres: null,
    obec: null,
    castObce: null,
    ulice: null,
    cisloDomu: null,
    psc: null,
    email: null,
    phone: null,
    bankAccountNumber: null
})

const aresLoading = ref<boolean>(false)
const submitted = ref<boolean>(false)

const rules = {
    // ic: {required: helpers.withMessage('IC je povinny parametr.', required), minLength: minLength(2)}
    ic: {required},
    companyName: {required, $autoDirty: true},
    okres: {required},
    obec: {required},
    castObce: {required},
    ulice: {required},
    cisloDomu: {required},
    psc: {required},
    email: {required, email},
    phone: {required},
    bankAccountNumber: {required}
}

// Inject dependencies
const axios = inject<AxiosStatic>('axios')

// Define used properties
const v$ = useVuelidate(rules, formData)
const userStore = useUserStore()

// Define emits


// Define functions
function handleSubmit(isFormValid: boolean) {
    submitted.value = true
    if (isFormValid) {
        saveCompany()
    }else {
      console.error('Form is not valid!', v$)
    }
}

function saveCompany() {
    const primary = !userStore.hasPrimaryCompany
    let path = "/company"
    if (primary) {
        path = "/company/primary"
    }
    axios?.post(path, buildData()).then((response) => {
        if (response.status >= 200 && response.status <= 299) {
            if (primary)
                userStore.setCompany(response.data)
            emits('companyCreated', response.data)
            resetForm()
        } else {
            // message.error('Ulozeni spolecnosti se nezdarilo!')
            console.error(response)
        }
    })
}

function resetForm() {
    formData.ic = null
    formData.companyName = null
    formData.dic = null
    formData.okres = null
    formData.obec = null
    formData.castObce = null
    formData.ulice = null
    formData.cisloDomu = null
    formData.psc = null
    formData.email = null
    formData.phone = null
    formData.bankAccountNumber = null
    submitted.value = false
}

function buildData(): any {

    const primary = !userStore.hasPrimaryCompany

    return {
        ic: formData.ic,
        companyName: formData.companyName,
        dic: formData.dic,
        okres: formData.okres,
        obec: formData.obec,
        castObce: formData.castObce,
        ulice: formData.ulice,
        cisloDomu: formData.cisloDomu,
        ps: formData.psc,
        email: formData.email,
        phoneNumber: formData.phone,
        bankAccountNumber: formData.bankAccountNumber,
        platceDph: formData.platceDph,
        primaryAccount: primary
    }
}

function loadDataFromAres() {
    aresLoading.value = true
    axios?.get(`/ares/` + formData.ic).then(response => {
        aresLoading.value = false
        if (response.status === 200) {
            formData.ic = response.data.ic
            formData.companyName = response.data.companyName
            formData.dic = response.data.dic
            formData.platceDph = response.data.platceDph
            formData.okres = response.data.okres
            formData.obec = response.data.obec
            formData.castObce = response.data.castObce
            formData.ulice = response.data.ulice
            formData.cisloDomu = response.data.cisloDomu
            formData.psc = response.data.psc
        } else {
            console.error('Can not load ARES info for the IC', response)
        }
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Panel), {
    header: "Create company",
    toggleable: true,
    collapsed: __props.collapsed,
    class: "mt-2"
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (handleSubmit(!_unref(v$).$invalid)), ["prevent"])),
        class: "p-fluid"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_unref(InputText), {
                  class: _normalizeClass({'p-invalid':_unref(v$).ic.$invalid}),
                  modelValue: _unref(v$).ic.$model,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).ic.$model) = $event))
                }, null, 8, ["class", "modelValue"]),
                _createVNode(_unref(Button), {
                  icon: "pi pi-search",
                  class: "p-button-warning",
                  onClick: loadDataFromAres
                })
              ]),
              (_unref(v$).ic.$invalid && submitted.value)
                ? (_openBlock(), _createElementBlock("small", _hoisted_6, _toDisplayString(_unref(v$).ic.required.$message.replace('Value', 'IC')), 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode(InputField, {
              id: "companyName",
              class: "col-2",
              label: "Company Name 2",
              vualidate: _unref(v$).companyName,
              submitted: submitted.value,
              modelValue: formData.companyName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.companyName) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", {
              class: _normalizeClass(props.class)
            }, [
              _hoisted_7,
              _createVNode(_unref(InputText), {
                id: "dic",
                class: "p-inputtext",
                modelValue: formData.dic,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.dic) = $event))
              }, null, 8, ["modelValue"])
            ], 2),
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(" Platce DPH:  "),
                _createVNode(_unref(InputSwitch), {
                  modelValue: formData.platceDph,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.platceDph) = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(InputField, {
              id: "okres",
              class: "col-2",
              label: "Okres",
              vualidate: _unref(v$).okres,
              submitted: submitted.value,
              modelValue: formData.okres,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.okres) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createVNode(InputField, {
              id: "obec",
              class: "col-2",
              label: "Obec",
              vualidate: _unref(v$).obec,
              submitted: submitted.value,
              modelValue: formData.obec,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.obec) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createVNode(InputField, {
              id: "castObce",
              class: "col-2",
              label: "Cast obce",
              vualidate: _unref(v$).castObce,
              submitted: submitted.value,
              modelValue: formData.castObce,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.castObce) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createVNode(InputField, {
              id: "ulice",
              class: "col-2",
              label: "Ulice",
              vualidate: _unref(v$).ulice,
              submitted: submitted.value,
              modelValue: formData.ulice,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.ulice) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createVNode(InputField, {
              id: "cisloDomu",
              class: "col-1",
              label: "Cislo Domu",
              vualidate: _unref(v$).cisloDomu,
              submitted: submitted.value,
              modelValue: formData.cisloDomu,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.cisloDomu) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createVNode(InputField, {
              id: "PSC",
              class: "col-1",
              label: "PSČ",
              vualidate: _unref(v$).psc,
              submitted: submitted.value,
              modelValue: formData.psc,
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.psc) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(InputField, {
              id: "email",
              class: "col-2",
              label: "E-mail",
              vualidate: _unref(v$).email,
              submitted: submitted.value,
              modelValue: formData.email,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.email) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createVNode(InputField, {
              id: "phone",
              class: "col-2",
              label: "Phone",
              vualidate: _unref(v$).phone,
              submitted: submitted.value,
              modelValue: formData.phone,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.phone) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createVNode(InputField, {
              id: "bankAccountNumber",
              class: "col-2",
              label: "Cislo uctu",
              vualidate: _unref(v$).bankAccountNumber,
              submitted: submitted.value,
              modelValue: formData.bankAccountNumber,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.bankAccountNumber) = $event))
            }, null, 8, ["vualidate", "submitted", "modelValue"]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Create",
                class: "p-button-lg"
              })
            ])
          ])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["collapsed"]))
}
}

})